import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { currentDomain, currentPath } from "../Index";
import { usePromotionsData } from "../data/PromotionData";
import { useNavigate } from "react-router-dom";
import useAppPromotionTheme from "../hooks/useAppPromotionTheme";

export default function CashAndCard({ isLightMode }) {
	const isAppPromo = useAppPromotionTheme(isLightMode);
	const { promotionsData } = usePromotionsData();
	const data = promotionsData.find((promo) => promo.title === "VP Cash & Card");
	const [isMobile, setIsMobile] = useState(false);
	const [isLoggedIn, setIsLoggedIn] = useState(false);

	const navigate = useNavigate();

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 841);
		};
		handleResize();
		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	useEffect(() => {
		const loggedInState = localStorage.getItem("isLoggedIn") === "true";
		setIsLoggedIn(loggedInState);
	}, []);

	useEffect(() => {
		if (!data) {
			navigate("/not-found");
		}
	}, [data, navigate]);

	if (!data) return null;

	return (
		<>
			<Helmet>
				<meta charSet="utf-8" />
				<title>VP Cash & Card Double Rewards</title>
				<link rel="icon" href="/images/fav.webp" sizes="32x32" />
				<meta name="description" content="ddd" />
				<link rel="canonical" href={`${currentDomain}${currentPath}`} />
			</Helmet>
			<div className="promotion-page-main all-page-main-container-min-height">
				<div className="promotion-page-container main-container-global-adjusted-padding">
					<div className="promotion-tnc-page">
						<div className="promotion-page-breadcrumb">
							<a
								href={
									isAppPromo
										? "/promotion/".replace("/promotion", "/app-promotion")
										: "/promotion/"
								}
							>
								Promotions
							</a>
							/ <span>{data.title}</span>
						</div>
						<div className="promotion-tnc-banner">
							<img
								src={isMobile ? data.imgSrc : data.bannerSrc}
								alt={`FGH${data.title}`}
							/>
							<div className="promotion-tnc-content">
								<div className="promotion-tnc-info">
									<div
										className={`promotion-indication-message ${data.promotionMessage.class}`}
									>
										{data.promotionMessage.text}
									</div>
									<h1>VP Cash & Card</h1>
									<h2>Double Rewards</h2>
									<div className="promotion-tnc-period">
										<strong> Event Period: </strong>
										<span>
											{" "}
											August 17 (12AM) - September 13 (11:59PM), 2026{" "}
										</span>
									</div>
								</div>
								<div className="promotion-tnc-mechanic-content">
									<strong>Promo Mechanics</strong>
									<ol>
										<li>
											All FGH players are invited to join this double-exciting
											in-game promo of Vertext Play (VP).
										</li>
										<li>
											There will be two (2) tasks, and each task has a
											corresponding rewards.
										</li>

										<li style={{ listStyle: "none" }}>
											<strong className="highlight">
												TASK FOR CASH (Weekly : Aug 17-23 & Sep 7-13)
											</strong>
											: Earned by meeting wagering requirements; redeemable for
											cash after countdown
											<ul style={{ marginBottom: "0" }}>
												<li>
													Meet the wagering requirement per tier to earn a Cash
													Ticket; added to Backpack (ITEMS tab).
												</li>
												<div className="table-wrapper">
													<table
														className="promotion-tnc-table"
														style={{ minWidth: "0" }}
													>
														<thead>
															<tr>
																<th>Level</th>
																<th>Turnover Requirement</th>
																<th>Reward</th>
															</tr>
														</thead>

														<tbody>
															<tr>
																<td>1</td>
																<td>200.00</td>
																<td>₱3.00</td>
															</tr>

															<tr>
																<td>2</td>
																<td>500.00</td>
																<td>₱5.00</td>
															</tr>

															<tr>
																<td>3</td>
																<td>1,000.00</td>
																<td>₱10.00</td>
															</tr>

															<tr>
																<td>4</td>
																<td>2,000.00</td>
																<td>₱15.00</td>
															</tr>

															<tr>
																<td>5</td>
																<td>4,000.00</td>
																<td>₱20.00</td>
															</tr>

															<tr>
																<td>6</td>
																<td>10,000.00</td>
																<td>₱50.00</td>
															</tr>

															<tr>
																<td>7+</td>
																<td>20,000.00</td>
																<td>₱100.00</td>
															</tr>
														</tbody>
													</table>
												</div>
												<li>
													Redeemable 24 hours after claiming. Manual redemption
													only — NOT automatic.
												</li>
												<li>
													Once redeemable, expires and is auto-collected if not
													redeemed within 72 hours. No reissuance.
												</li>
												<li>
													Complete 6 levels to earn rewards! Higher levels are
													more challenging. After Level 6, the same requirements
													will apply to each new level. Depending on the event,
													you can either complete the levels once or keep
													repeating them to earn more rewards.
												</li>
												<li>
													Unclaimed tickets are auto-collected by the system
													after the event ends. No reissuance.
												</li>
												<li>
													Claim/Redeem Cap : Max 99 per action. E.g. if holding
													100, first action claims 99; tap again for the
													remaining 1.
												</li>
											</ul>
										</li>
										<li style={{ listStyle: "none" }}>
											<strong className="highlight">
												TASK FOR CARD (Daily)
											</strong>
											: Reach a required number of spins to collect CARD/S to
											trigger FREE SPINS or FEATURE GAMES.
											<ul style={{ marginBottom: "0" }}>
												<li>
													When the accumulated spin count reaches the target
													threshold, a Card is earned and added to the Backpack
													upon claiming.
												</li>
												<li>
													The card received always corresponds to the game the
													player is currently playing.
												</li>
												<li>Higher bet amounts yield better card rewards.</li>
												<li>
													Each player's initial target spin count is not fixed —
													it is adjusted dynamically based on event data.
													Players already in an active event are not affected by
													later adjustments.
												</li>
												<li>
													Players cycle through 3–4 different target spin count
													sets, determined by player type.
												</li>
												<li>
													The maximum accumulated spin target is 1,500. Once
													reached, all future targets are fixed at 1,500.
												</li>
												<li>
													Spin counts are cumulative and never reset, even after
													extended periods of inactivity.
												</li>
												<li>
													Winnings from the free spins & feature games using the
													card will be automatically added to player's balance.
												</li>
											</ul>
										</li>
										<li>
											<strong className="highlight">
												Players need to open any VP slots available in the
												website to see and do the tasks accordingly.
											</strong>
										</li>
										<li>
											<strong className="highlight">
												FGH & VP reserve the right to modify, suspend, or
												terminate the promotion at any time without prior
												notice. All decisions made by the company regarding this
												promotion are final.
											</strong>
										</li>
									</ol>

									{!isAppPromo && (
										<div className="promotion-tnc-cta">
											<a
												className="promotion-cta-btn"
												href="/slots/?provider=VP"
											>
												PLAY NOW
											</a>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
